import React from 'react';
import Cookies from 'universal-cookie';
import { SERVER } from '../../../common/const/networkUrls';
import { LabelText } from '../../Language/LabelText';
import Spinner from '../Spinner/Spinner';
import { clearCookiesStorageAndRedirect } from '../../../common/utility/utility';
import './index.css';
import backgroundImage from '../../../assets/images/background1_large.svg';
import CookieConsent from "react-cookie-consent";

export function Login(props) {

    const cookies = new Cookies();

    const clearCookiesLocalStorageAndRedirect = () => {
        clearCookiesStorageAndRedirect(true);
    }

    const handlerOnLoginClick = () => {
        clearCookiesLocalStorageAndRedirect();
        props.setIsLoading(true);
    }

    const isToken = cookies.get("token") && cookies.get("token") !== "";
    const isAuthenticated = localStorage.getItem('isAuth') && localStorage.getItem('isAuth') === "true";
    const isLoading = localStorage.getItem('isLoading') && localStorage.getItem('isLoading') === "true";
    const isInternalUser = props.internalUsers;

    const LoginContent = () => {
        return (
            <div className="main-contents">
                <div className="main-content">
                    <div style={{ float: 'left' }}>
                        <p className="App-content-background-welcome">
                            <LabelText tid="welcomeline1" /><br />
                            <LabelText tid="welcomeline2" />
                        </p>
                        <div className="login-btn-container">
                            <button className="login-btn" tabIndex="0" onClick={() => handlerOnLoginClick()}>
                                <LabelText tid="Login" />
                            </button>
                        </div>
                        <div className="password-reset-container">
                            <div className="password-reset">
                                <LabelText tid="password_reset" />
                            </div>
                            <a className="click-here" tabIndex="0" href={SERVER.SERVICES.passwordrResetUrl} target="_blank">
                                <LabelText tid="click_here" />
                            </a>
                        </div>
                    </div>
                    <div className="img-row"><div className="img-column">
                        <img className="background-image" src={backgroundImage} ></img>
                    </div></div>
                </div>
                <CookieConsent
                    location="bottom"
                    buttonText="OK"
                    cookieName="CookieConsent"
                    style={{ background: "#eff4f9", color: "#25336c" }}
                    buttonStyle={{ color: "white", fontSize: "13px", background: "black" }}
                    debug={true}
                    overlay
                >
                    <b><LabelText tid="cookieSettings" /></b>
                    <br />
                    <LabelText tid="cookiesMessage" />
                </CookieConsent>
            </div>
        )
    };

    const DiscontinuedContent = () => {
        return (
            <div className="main-contents">
                <div className="main-content">
                    <div style={{ float: 'left' }}>
                        <p className="App-content-background-welcome">
                            <LabelText tid="welcomeline1" />
                        </p>
                        <div class="discontinue-container">
                            <div class="discontinue-txt" tabindex="0">
                                <p>
                                    <LabelText tid="discontinued-msg-1"/>
                                </p>
                                <p>
                                    <LabelText tid="discontinued-msg-2"/>                                    
                                </p>
                                <ul>
                                    <li>
                                        <LabelText tid="contact-account-manager"/>
                                    </li>
                                    <li>
                                        <LabelText tid="send-email-text"/>
                                        <a
                                            href="mailto:23.omzetcijfers-chiffresdaffaires@belgiantrain.be"
                                            style={{ color: "#0056b3", textDecoration: "underline" }}
                                        >
                                            <LabelText tid="email-id"/>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                    <div className="img-row"><div className="img-column">
                        <img className="background-image" src={backgroundImage} ></img>
                    </div></div>
                </div>
                <CookieConsent
                    location="bottom"
                    buttonText="OK"
                    cookieName="CookieConsent"
                    style={{ background: "#eff4f9", color: "#25336c" }}
                    buttonStyle={{ color: "white", fontSize: "13px", background: "black" }}
                    debug={true}
                    overlay
                >
                    <b><LabelText tid="cookieSettings" /></b>
                    <br />
                    <LabelText tid="cookiesMessage" />
                </CookieConsent>
            </div>
        )
    };

    const AuthLandingContent = () => {
        return (<div className="App-auth-content-background"></div>);
    }

    const LoadingContent = () => {
        return (<div className="App-auth-content-background"><Spinner isLogin={true} /></div>);
    }

    return (
        <div>
            {isInternalUser ? !isLoading ?
                (!isAuthenticated || !isToken) ? <LoginContent /> : <AuthLandingContent />
                : <LoadingContent />
            :<DiscontinuedContent/>}
        </div>
    )
}